import { assetUrl } from '../lib/api';
import { useTenant } from '../lib/tenant';
import { cx } from './kit';

/** Super APP işareti: zümrüt kare üzerinde altın üç çubuk (ikonla aynı). */
export function BrandMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 64 64" className={className} role="img" aria-label="Super APP">
      <defs>
        <linearGradient id="bm-bg" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#0B5A44" />
          <stop offset="1" stopColor="#03261D" />
        </linearGradient>
        <linearGradient id="bm-gold" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#ECCD70" />
          <stop offset="1" stopColor="#BE932C" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="15" fill="url(#bm-bg)" />
      <g fill="url(#bm-gold)">
        <path d="M17.5 16h7.6l-8.1 32H9.4z" transform="translate(4 0)" />
        <path d="M31.1 16h7.6l-8.1 32H23z" transform="translate(4 0)" />
        <path d="M44.7 16h7.6l-8.1 32h-7.6z" transform="translate(4 0)" />
      </g>
    </svg>
  );
}

/** İşletme logosu (varsa) yoksa baş harfli altın rozet. */
export function TenantLogo({ size = 44, className }: { size?: number; className?: string }) {
  const { bootstrap } = useTenant();
  const logo = assetUrl(bootstrap?.brand?.logoUrl);
  const name = bootstrap?.tenant.name ?? '';
  if (logo) {
    return <img src={logo} alt={name} width={size} height={size} className={cx('rounded-2xl bg-white object-contain p-1 shadow-card', className)} style={{ width: size, height: size }} />;
  }
  const initials = name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toLocaleUpperCase('tr-TR'))
    .join('');
  return (
    <span className={cx('gold-fill grid place-items-center rounded-2xl font-extrabold tracking-tight shadow-glow', className)} style={{ width: size, height: size, fontSize: size * 0.38 }} aria-label={name}>
      {initials || '★'}
    </span>
  );
}
